module.exports = __webpack_public_path__ + "img/sex_woman_active.8429f588.png";